export default __webpack_public_path__ + "static/media/caera-5.0ec7b895.webm";